(function () {
    const $selects = $('select[name="age"], select[name="passengers"], select[name="country_of_residence"]');

    if (!$selects.length || typeof $.fn.selectize !== 'function') {
        return;
    }

    $selects.selectize({
        selectOnTab: true,
        create: false,
    });
})();
